/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Invalid_JsonInputs */

const en_tree_invalid_json = /** @type {(inputs: Tree_Invalid_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid JSON: cannot display tree view`)
};

const ko_tree_invalid_json = /** @type {(inputs: Tree_Invalid_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유효하지 않은 JSON: 트리 뷰를 표시할 수 없습니다`)
};

const ja_tree_invalid_json = /** @type {(inputs: Tree_Invalid_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効なJSON: ツリービューを表示できません`)
};

/**
* | output |
* | --- |
* | "Invalid JSON: cannot display tree view" |
*
* @param {Tree_Invalid_JsonInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const tree_invalid_json = /** @type {((inputs?: Tree_Invalid_JsonInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Invalid_JsonInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_invalid_json(inputs)
	if (locale === "ko") return ko_tree_invalid_json(inputs)
	return ja_tree_invalid_json(inputs)
});